import React, { useContext, useEffect, useState } from 'react';

// Tabelas
import { DataGrid, ColDef, ValueFormatterParams } from '@material-ui/data-grid';

// Images
import Freetakistan from '../../assets/images/Freetakistan.png';

// Components
import Header from '../../components/Header/index';

// Firebase
import { db } from '../../utils/firebaseConfig';

// Context
import AuthContext from '../../Context/context';

// Material-ui
import { IconButton, Tooltip, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import { MoreVert, VerifiedUser, Error } from '@material-ui/icons';

import './usuariosAdmin.css';

const UsuariosAdmin = () => {
  const { isAdmin, currentUser } = useContext(AuthContext);

  const [users, setUsers] = useState<any>([]);
  const [aviso, setAviso] = useState('');

  const [userSelected, setUserSelected] = useState<any>({});

  const [isLoading, setIsLoading] = useState(false);
  const [permissionDenied, setPermissionDenied] = useState(false);

  // Menu booleans
  const [openMenu, setShowMenu] = useState<null | HTMLElement>(null);

  const showMenu = (event: React.MouseEvent<HTMLDivElement>) => {
    setShowMenu(event.currentTarget);
  };

  const hideMenu = () => {
    setShowMenu(null);
  };

  // Dialogs
  const [alterUserDialog, setShowAlterUser] = useState(false);

  const showAlterUser = () => setShowAlterUser(true);

  const hideAlterUser = () => setShowAlterUser(false);

  useEffect(() => {
    getAllUsers();
  }, [])

  const getAllUsers = () => {
    // Retorna todos os usuários, exceto o administrador padrão
    db.collection('Usuarios').onSnapshot(
      resp => {
        var u = resp.docs.map((user: any) => {
          return {
            id: user.id,
            email: user.data().email,
            permissao: user.data().isAdmin ? 'Administrador Takistanes' : 'Comum',
            emailVerified: user.data().emailVerified
          }
        })

        setUsers(u);
      })
  }

  const AlterUser = () => {
    if (userSelected.id === currentUser?.uid) {
      setAviso('Você não tem permissão para editar seu próprio usuário.')
      return setPermissionDenied(true);
    }

    db.collection('Usuarios').doc(userSelected.id).get()
      .then(resp => {
        if (resp.exists) {
          let user = {
            id: resp.id,
            email: resp.data()?.email,
            isAdmin: resp.data()?.isAdmin
          }

          db.collection('Usuarios').doc(resp.id).update({
            isAdmin: !user.isAdmin
          })
            .catch(err => {
              console.log('Houve um erro na alteração da permissão do usuário.')
            })
        }
        hideAlterUser();
        setUserSelected({});
      })
      .catch(err => {
        console.log('Houve um erro ao recuperar o usuário.');
      })

  }

  const columns: ColDef[] = [
    { field: 'email', headerName: 'Email', width: 350 },
    { field: 'permissao', headerName: 'Permissão', width: 280 },
    {
      field: 'emailVerified', headerName: 'Verificado?', width: 105,
      renderCell: (params: ValueFormatterParams) => (
        <div style={{margin: '0 auto'}}>
          {
            params.row.emailVerified ?
              <VerifiedUser style={{ color: green[500] }} />
              :
              <Error style={{ color: red[500] }} />
          }
        </div>
      )
    },
    {
      field: 'actions',
      headerName: 'Ações',
      width: 100,
      renderCell: (params: ValueFormatterParams) => (
        <div style={{margin: '0 auto'}}>
          {
            isAdmin &&
            <div>
              <Tooltip title="Opções" aria-controls="simple-menu" aria-haspopup="true" onClick={(e) => {
                setUserSelected(params.row);
                showMenu(e);
              }}>
                <IconButton>
                  <MoreVert />
                </IconButton>
              </Tooltip>
              <Menu
                id="simple-menu"
                anchorEl={openMenu}
                keepMounted
                open={Boolean(openMenu)}
                onClose={hideMenu}
              >
                <MenuItem onClick={() => {
                  hideMenu();
                  showAlterUser();
                }}>
                  {userSelected.permissao === 'Comum' ? 'Tornar Admin' : 'Tornar Comum'}
                </MenuItem>
                <MenuItem onClick={() => {
                  hideMenu();
                }}>
                  Desativar usuário (em breve)
                </MenuItem>
              </Menu>
            </div>

          }
        </div>
      )
    }
  ];

  return (
    <div>
      <Header />

      <div className='text-center'>
        <img src={Freetakistan} alt='Freetakistan Logo' style={{ width: '150px' }} />
      </div>

      <br />
      <h3 style={{ textAlign: 'center' }}>Lista de usuários</h3>
      <hr />

      <div style={{ marginTop: '3em' }}>
        <div className="table-container" style={{ height: 500, margin: '0 auto' }}>
          <DataGrid pagination rows={users} columns={columns} pageSize={5} rowsPerPageOptions={[5, 10, 25, 50]}
          />
        </div>
      </div>

      <p style={{ textAlign: 'center' }}>
        <small>Clique em alguma linha para ter mais detalhes das opções da lista</small>
      </p>

      {/* Modal para Alterar Usuário */}
      <Dialog open={alterUserDialog} aria-labelledby="form-dialog-title2" onClose={() => {
        hideAlterUser();
        setUserSelected({});
        setPermissionDenied(false);
      }}>
        <DialogTitle id="form-dialog-title2" >Alterar permissão de usuário</DialogTitle>
        <DialogContent>
          {
            permissionDenied ?
              <DialogContentText color="error">
                {aviso}
              </DialogContentText>
              :
              <DialogContentText>
                Você tem certeza que deseja alterar a permissão do usuário <strong>"{userSelected.email}"</strong> para <strong>{userSelected.permissao === 'Comum' ? 'Admin' : 'Comum'}</strong>?
              </DialogContentText>
          }
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => {
            hideAlterUser();
            setUserSelected({});
            setPermissionDenied(false);
          }}>
            Cancelar
          </Button>
          <Button color="primary" onClick={() => {
            AlterUser();
          }}>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      {/* FIM do Modal para Alterar Usuário */}

    </div>
  );
}

export default UsuariosAdmin;
